export const AGENT_VIEWS = {
    sidebar: 'sidebar',
    window: 'window',
}
